var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "course-progress" },
    [
      _c(
        "words-progress",
        _vm._g(
          { attrs: { user: this.user, course: this.course } },
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _c("weekly", _vm._g({ attrs: { course: this.course } }, _vm.$listeners)),
      _vm._v(" "),
      _c("day-goals", { attrs: { course: this.course } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }